import { useCompanyContext } from '@/features/_contexts/company-context'
import { FacilityProvider } from '@/features/_contexts/facility-context'
import { queries } from '@/features/_lib/react-query'
import { useQuery } from '@tanstack/react-query'
import { Outlet, createFileRoute, useLocation, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const Route = createFileRoute('/_authed/companies/$companySlug/facilities/$facilitySlug')({
  component: FacilityLayout,
})

function FacilityLayout() {
  const { facilitySlug, companySlug } = Route.useParams()
  const { pathname } = useLocation()
  const company = useCompanyContext()
  const navigate = useNavigate()
  const isUUID = UUID_REGEX.test(facilitySlug)

  // Resolve slug → facility
  const { data: facility } = useQuery({
    ...queries.companies.facilityBySlug(company?.id ?? '', facilitySlug),
    enabled: !isUUID && !!company,
  })

  // Fallback: if param is a UUID, fetch by ID and redirect to slug
  const { data: facilityById } = useQuery({
    ...queries.companies.facility(company?.id ?? '', facilitySlug),
    enabled: isUUID && !!company,
  })

  useEffect(() => {
    if (isUUID && facilityById) {
      // Preserve the rest of the path after the facility slug
      const facilityPrefix = `/companies/${companySlug}/facilities/${facilitySlug}`
      const suffix = pathname.startsWith(facilityPrefix)
        ? pathname.slice(facilityPrefix.length)
        : ''
      navigate({
        to: `/companies/${companySlug}/facilities/${facilityById.slug}${suffix}` as any,
        replace: true,
      })
    }
  }, [isUUID, facilityById, companySlug, facilitySlug, pathname, navigate])

  if (isUUID) return null

  return (
    <FacilityProvider value={facility ?? null}>
      <Outlet />
    </FacilityProvider>
  )
}
